import React, { Dispatch, SetStateAction, useEffect } from 'react';
import styles from '../SelectLocation/SelectLocation.module.css';
import iconBack from '../../../../images/icon-chevron-left.svg';
import { lockersList } from '../../../../constants/constants';
import { fetchLockerWiseAvailabilityAndAppointments } from '../../../../redux/locker-wise-availability/actions/lockerWiseAvailability.actions';
import { useDispatch } from 'react-redux';
import { AppDispatch, IRootState } from '../../../../redux/rootReducer';
import { useSelector } from 'react-redux';
import { LockerWiseAvailabilityAndAppointmentsState } from '../../../../redux/locker-wise-availability/interfaces/lockerWiseAvailability.interface';
import TinyLoader from '../../../common/tiny-loader/TinyLoader';

interface AddAvailabilityObjProps {
    closingTime: string;
    endDate: string;
    locationId: string;
    locationName: string;
    locker: number | null;
    openingTime: string;
    startDate: string;
    unitId: string;
    unitName: string;
}
interface Props {
    setShowUnits: (active: boolean) => void;
    setShowLocker: (active: boolean) => void;
    setShowCalendar: (active: boolean) => void;
    setAddAvailabilityObj: Dispatch<SetStateAction<AddAvailabilityObjProps>>;
    addAvailabilityObj: AddAvailabilityObjProps;
}

const SelectLocker = ({ setShowUnits, setShowLocker, setShowCalendar, setAddAvailabilityObj, addAvailabilityObj }: Props) => {
    const dispatch = useDispatch<AppDispatch>();

    const selectedLocationLockersCount = useSelector<IRootState, LockerWiseAvailabilityAndAppointmentsState>(
        (state) => state.lockerWiseAvailabilityAndAppointments,
    ).lockerCounts;

    const loading = useSelector<IRootState, LockerWiseAvailabilityAndAppointmentsState>(
        (state) => state.lockerWiseAvailabilityAndAppointments,
    ).loading;

    useEffect(() => {
        if (addAvailabilityObj.locationId) {
            dispatch(fetchLockerWiseAvailabilityAndAppointments(addAvailabilityObj.locationId));
        }
    }, [addAvailabilityObj.locationId]);

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div
                    className={styles.back}
                    onClick={() => {
                        setShowLocker(false);
                        setShowUnits(true);
                    }}>
                    <img src={iconBack} alt="back" />
                </div>
                <h2 className={styles.title}>Lockers</h2>
            </div>
            <div className={styles.body}>
                <h3 className={styles.subTitle}>Select a locker</h3>
                {loading ? (
                    <TinyLoader />
                ) : (
                    <div className={selectedLocationLockersCount === 12 ? styles.maxLockersCounts : styles.tabs}>
                        {Array(selectedLocationLockersCount)
                            .fill('')
                            .map((locker, index) => (
                                <span
                                    onClick={() => {
                                        setAddAvailabilityObj((prevState) => {
                                            return {
                                                ...prevState,
                                                locker: index + 1,
                                            };
                                        });
                                        setShowLocker(false);
                                        setShowCalendar(true);
                                    }}
                                    key={index + 1}
                                    className={index + 1 === addAvailabilityObj.locker ? styles.selected : styles.tab}>
                                    Locker {index + 1}
                                </span>
                            ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SelectLocker;
